prevSectionType